module.exports = __webpack_public_path__ + "img/hand-love.4e11dd58.svg";